<h1 mat-dialog-title style="font-family: 'Open Sans', sans-serif;"  i18n>Atención</h1>
<div mat-dialog-content i18n>
    <p>Aumente el nivel de zoom para visualizar los elementos seleccionados</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(false)" color="accent" i18n>Cancelar</button>
    <button mat-button (click)="close(true)" i18n>Zoom</button>
</div>
